const mutations = {
    setReports(state, payload) {
        state.reports = payload;
      },
    setIMEIAction(state, payload) {
      state.imeiAction = payload;
    },
    setStorePayoutReportDataToRedirectNERPAction(state, payload) {
      state.storePayoutReportDataToRedirectNERPData = payload;
    }
}

export default mutations;